// extracted by mini-css-extract-plugin
export default {"addIcon":"TopRightLink_addIcon__2iZwo","link":"TopRightLink_link__NhrIM"};